//
$('body').on('click', 'button[data-action="redirect"]', zeno_debounce(200, function(event) {
    window.location = $(this).data('zeno-clickable-url');
}));

//show any additional fields for the selected category
$('body').on('change', 'select[name="activity-category"]', zeno_debounce(200, function(event) {
    updateForm();
}));

//
$('body').on('change', 'div.activity-type-dropdown', zeno_debounce(200, function(event) {
    updateForm();
}));

setTimeout(updateForm, 300);

//handle the requirement for a hidden class...
const customFormStyles = new CSSStyleSheet();
customFormStyles.replaceSync(`.hidden { display: none; }`);
document.adoptedStyleSheets = [ ...document.adoptedStyleSheets, customFormStyles ];

//
function updateForm () {

    $('div.activityToken').addClass('hidden');

    $('div.activity-type-dropdown').addClass('hidden').filter('[data-category="' + $('select[name="activity-category"]').val() + '"]').removeClass('hidden');

    const selectedActivity = $('select[name="activity-category"] option:selected').val().toLowerCase();
    const selectedOption   = $(`select[name="activity-type-${selectedActivity}"] option:selected`).data('activitytype').toLowerCase();

    // use the name
    if (selectedActivity == 'reading') {
        $('select[name="activity-duration"] option:not([value="1"])' ).prop('hidden',true);
        $('select[name="activity-duration"]').val(1);
        $('div.requireAssessment').addClass('hidden');
        $('div.requireAssessment').addClass('hidden');

        if (selectedOption == 'nrla property magazine') {
            $('input[name="activity-organisation"]').val('NRLA');
            $('div.activityOrganisation').addClass('hidden');

            // token
            $('div.activityToken').removeClass('hidden');
            $('input[name="activity-token"]').closest('div.input-group').addClass('input-required');
            $('input[name="activity-token"]').prop('required',false);
        } else {
            $('div.activityOrganisation').removeClass('hidden');

            // token
            $('div.activityToken').addClass('hidden');
            $('input[name="activity-token"]').prop('required',false);
        }
    } else {
        $('select[name="activity-duration"] option' ).prop('hidden',false);
        $('select[name="activity-duration"]').val();

        $('div.requireAssessment').removeClass('hidden');
        $('div.activityOrganisation').removeClass('hidden');

        // token
        $('div.activityToken').addClass('hidden');
        $('input[name="activity-token"]').prop('required',false);
    }
}

//
function updateTextareaCounter(element) {

    if ($(element).find(' + small.counter').length == 0) {
        $(element).after('<small class="counter" style="float: right;"></small>');
    }

    var maxCharacters = 1024;
    var totalCharacters = $(element).val().length;
    $(element).find(' + small.counter').css('color', ((totalCharacters > maxCharacters) ? '#ff0024' : '#252525'));
    $(element).find(' + small.counter').text(totalCharacters + '/' + maxCharacters);

}

//
$('body').on('keyup', 'textarea[name="activity-member-comments"]', function(event) {
    updateTextareaCounter(event.target);
});
updateTextareaCounter(document.querySelector('textarea[name="activity-member-comments"]'));

//
$('body').on('change', 'div[data-name="activity-type-dropdown"] select', zeno_debounce(200, function(event) {
    var tokenType = $(this).find('option[value="' + $(this).val() + '"]').data('tokentype');
    if (tokenType !== '') {
        $('#verificationToken').removeClass('hidden');
    } else {
        if (!$('#verificationToken').hasClass('hidden')) {
            $('#verificationToken').addClass('hidden');
        }
    }
}));